import { memo } from 'react';
import Card from './ui/Card';
import { GAME_MODES, GAME_MODE_CONFIG } from '../config/gameConfig';

/**
 * GameModeSelector Component
 * Allows users to select game mode during setup
 * Memoized to prevent unnecessary re-renders
 */
const GameModeSelector = memo(function GameModeSelector({
  selectedMode,
  onModeSelect,
}) {
  const modes = Object.values(GAME_MODE_CONFIG);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {modes.map((mode) => (
        <Card
          key={mode.key}
          onClick={() => onModeSelect(mode.key)}
          selected={selectedMode === mode.key}
          selectable={true}
          className="text-center"
        >
          <div className="text-6xl mb-4">{mode.icon}</div>
          <h3 className="text-2xl font-bold mb-2">{mode.label}</h3>
          <p className="text-gray-600 mb-4">{mode.description}</p>

          {/* Mode details */}
          <div className="text-sm text-gray-500 space-y-1">
            {mode.lives === Infinity ? (
              <div>♾️ Uendelige liv</div>
            ) : (
              <div>❤️ {mode.lives} {mode.lives === 1 ? 'liv' : 'liv'}</div>
            )}

            {mode.hasTimer && (
              <div>⏱️ {mode.timeLimit} sekunder</div>
            )}

            {mode.progressiveDifficulty && (
              <div>📈 Stigende sværhedsgrad</div>
            )}

            {!mode.allowMistakes && (
              <div>⚠️ Ingen fejl tilladt</div>
            )}

            {mode.noHighScore && (
              <div>📝 Kun til øvelse</div>
            )}
          </div>
        </Card>
      ))}
    </div>
  );
});

export default GameModeSelector;
